// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progressBar {
  flex: 1 1 auto;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding: 0px 30px 30px 30px;
  width: 100%;
  max-width: calc(100% - 200px);
  box-sizing: border-box;
}
.progressBar::before,
.progressBar::after {
  content: '';
  flex: 1 1 0;
  min-width: 0;
}
.progressBar::-webkit-scrollbar {
  height: 8px;
}
.progressBar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.progressBar::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.progressBar::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.progressBar section {
  display: inline-block;
  position: relative;
}
.progressBar section .progressLine {
  display: inline-block;
  vertical-align: middle;
  width: 124px;
  height: 1px;
  background-color: #d4d4d4;
  margin: 2.5px 0;
}
.progressBar section .progressLine.completed,
.progressBar section .progressLine.current {
  background-color: #96dcff;
}
.progressBar section .progressText {
  position: absolute;
  width: 130px;
  right: -62px;
  top: calc(100% + 2px);
  color: #262626;
  font-size: 15px;
  line-height: 16px;
  opacity: 0.4;
  max-width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.progressBar section .progressText.clickable {
  cursor: pointer;
}
.progressBar section .progressText.completed {
  color: #96dcff;
}
.progressBar section .progressText.completed.clickable:hover {
  color: #0086c9;
}
.progressBar section .progressText.completed,
.progressBar section .progressText.current {
  font-weight: bold;
  opacity: 1;
}
.progressBar section .progressIcon {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 6px;
  height: 6px;
  border: 1px solid #d4d4d4;
  border-radius: 50%;
}
.progressBar section .progressIcon.completed {
  border: none;
}
.progressBar section .progressIcon.completed::before {
  content: '';
  position: absolute;
  left: 1px;
  top: -2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  z-index: 103;
}
.progressBar section .progressIcon.completed::after {
  content: '';
  position: absolute;
  left: -4px;
  top: -4px;
  width: 14px;
  height: 14px;
  border: 1px solid #96dcff;
  border-radius: 50%;
  background-color: #96dcff;
  z-index: 102;
}
.progressBar section .progressIcon.current {
  border: none;
}
.progressBar section .progressIcon.current::before {
  content: '';
  position: absolute;
  left: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #96dcff;
  z-index: 103;
}
.progressBar section .progressIcon.current::after {
  content: '';
  position: absolute;
  left: -4px;
  top: -4px;
  width: 14px;
  height: 14px;
  border: 1px solid #96dcff;
  border-radius: 50%;
  background-color: white;
  z-index: 102;
}
@media (max-width: 1000px) {
  .progressBar {
    padding: 10px 30px 20px 30px;
  }
  .progressBar section .progressLine {
    width: 66px;
  }
  .progressBar section .progressText {
    width: 72px;
    right: -33px;
    font-size: 12px;
  }
}
@media (max-width: 599px) {
  .progressBar {
    position: relative;
    top: 0;
    left: 0;
    margin: 4px auto;
    padding: 0 10px 20px 10px;
    width: 100%;
    max-width: calc(100% - 20px);
    background-color: transparent;
    border-bottom: none;
    justify-content: flex-start;
    scroll-padding-left: 10px;
  }
  .progressBar::before,
  .progressBar::after {
    content: '';
    flex: 1 1 0;
    min-width: 0;
  }
  .progressBar section:first-child {
    margin-left: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/FlowProgressBar.less"],"names":[],"mappings":"AAEA;EAMC,cAAA;EACA,cAAA;EACA,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,6BAAA;EACA,sBAAA;AAND;AAQC;;EAEC,WAAA;EACA,WAAA;EACA,YAAA;AANF;AASC;EACC,WAAA;AAPF;AAUC;EACC,mBAAA;EACA,kBAAA;AARF;AAWC;EACC,gBAAA;EACA,kBAAA;AATF;AAYC;EACC,gBAAA;AAVF;AA9BA;EA4CE,qBAAA;EACA,kBAAA;AAXF;AAlCA;EAgDG,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;AAXH;AAaG;;EAEC,yBAAA;AAXJ;AA9CA;EA8DG,kBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAbH;AAeG;EACC,eAAA;AAbJ;AAgBG;EACC,cAAA;AAdJ;AAgBI;EACC,cAAA;AAdL;AAkBG;;EAEC,iBAAA;EACA,UAAA;AAhBJ;AA3EA;EAgGG,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAlBH;AAqBG;EACC,YAAA;AAnBJ;AAqBI;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,6BAAA;EACA,2BAAA;EACA,wBAAA;EACA,YAAA;AAnBL;AAsBI;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AApBL;AAwBG;EACC,YAAA;AAtBJ;AAwBI;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAtBL;AAyBI;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;AAvBL;AA6BC;EAAA;IAEC,4BAAA;EA3BA;EAyBD;IAMG,WAAA;EA5BF;EAsBD;IAUG,WAAA;IACA,YAAA;IACA,eAAA;EA7BF;AACF;AAiCC;EAAA;IAEC,kBAAA;IACA,MAAA;IACA,OAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,4BAAA;IACA,6BAAA;IACA,mBAAA;IACA,2BAAA;IACA,yBAAA;EA/BA;EAgCA;;IAEC,WAAA;IACA,WAAA;IACA,YAAA;EA9BD;EAiCC;IACC,iBAAA;EA/BF;AACF","sourcesContent":["@import (reference) '../constants.less';\n\n.progressBar {\n\t@notStartedIconColour: #d4d4d4;\n\t@progressLineWidth: 124px;\n\t@progressLineHeight: 1px;\n\t@progressIconSize: 6px;\n\n\tflex: 1 1 auto;\n\tmargin: 0 auto;\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\toverflow-x: auto;\n\toverflow-y: hidden;\n\twhite-space: nowrap;\n\tpadding: 0px 30px 30px 30px;\n\twidth: 100%;\n\tmax-width: calc(100% - 200px);\n\tbox-sizing: border-box;\n\n\t&::before,\n\t&::after {\n\t\tcontent: '';\n\t\tflex: 1 1 0;\n\t\tmin-width: 0;\n\t}\n\n\t&::-webkit-scrollbar {\n\t\theight: 8px;\n\t}\n\n\t&::-webkit-scrollbar-track {\n\t\tbackground: #f1f1f1;\n\t\tborder-radius: 4px;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground: #888;\n\t\tborder-radius: 4px;\n\t}\n\n\t&::-webkit-scrollbar-thumb:hover {\n\t\tbackground: #555;\n\t}\n\n\tsection {\n\t\tdisplay: inline-block;\n\t\tposition: relative;\n\n\t\t.progressLine {\n\t\t\tdisplay: inline-block;\n\t\t\tvertical-align: middle;\n\t\t\twidth: @progressLineWidth;\n\t\t\theight: @progressLineHeight;\n\t\t\tbackground-color: @notStartedIconColour;\n\t\t\tmargin: ((@progressIconSize - @progressLineHeight) / 2) 0;\n\n\t\t\t&.completed,\n\t\t\t&.current {\n\t\t\t\tbackground-color: @paleBlue;\n\t\t\t}\n\t\t}\n\n\t\t.progressText {\n\t\t\tposition: absolute;\n\t\t\twidth: (@progressLineWidth + @progressIconSize);\n\t\t\tright: (-(@progressLineWidth / 2));\n\t\t\ttop: calc(100% + 2px);\n\t\t\tcolor: @lineColor;\n\t\t\tfont-size: 15px;\n\t\t\tline-height: 16px;\n\t\t\topacity: 0.4;\n\t\t\tmax-width: (@progressLineWidth + @progressIconSize);\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\ttext-align: center;\n\n\t\t\t&.clickable {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t&.completed {\n\t\t\t\tcolor: @paleBlue;\n\n\t\t\t\t&.clickable:hover {\n\t\t\t\t\tcolor: darken(@paleBlue, 40%);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.completed,\n\t\t\t&.current {\n\t\t\t\tfont-weight: bold;\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\n\t\t.progressIcon {\n\t\t\tposition: relative;\n\t\t\tdisplay: inline-block;\n\t\t\tvertical-align: middle;\n\t\t\twidth: @progressIconSize;\n\t\t\theight: @progressIconSize;\n\t\t\tborder: 1px solid @notStartedIconColour;\n\t\t\tborder-radius: 50%;\n\n\t\t\t@circleSize: 14px;\n\t\t\t&.completed {\n\t\t\t\tborder: none;\n\n\t\t\t\t&::before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 1px;\n\t\t\t\t\ttop: -2px;\n\t\t\t\t\twidth: 4px;\n\t\t\t\t\theight: 8px;\n\t\t\t\t\tborder: solid white;\n\t\t\t\t\tborder-width: 0 1px 1px 0;\n\t\t\t\t\t-webkit-transform: rotate(45deg);\n\t\t\t\t\t-moz-transform: rotate(45deg);\n\t\t\t\t\t-o-transform: rotate(45deg);\n\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\tz-index: (@flowProgressBarZIndex + 2);\n\t\t\t\t}\n\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: ((@progressIconSize - @circleSize) / 2);\n\t\t\t\t\ttop: ((@progressIconSize - @circleSize) / 2);\n\t\t\t\t\twidth: @circleSize;\n\t\t\t\t\theight: @circleSize;\n\t\t\t\t\tborder: 1px solid @paleBlue;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tbackground-color: @paleBlue;\n\t\t\t\t\tz-index: (@flowProgressBarZIndex + 1);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.current {\n\t\t\t\tborder: none;\n\n\t\t\t\t&::before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\twidth: @progressIconSize;\n\t\t\t\t\theight: @progressIconSize;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tbackground-color: @paleBlue;\n\t\t\t\t\tz-index: (@flowProgressBarZIndex + 2);\n\t\t\t\t}\n\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: ((@progressIconSize - @circleSize) / 2);\n\t\t\t\t\ttop: ((@progressIconSize - @circleSize) / 2);\n\t\t\t\t\twidth: @circleSize;\n\t\t\t\t\theight: @circleSize;\n\t\t\t\t\tborder: 1px solid @paleBlue;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tbackground-color: white;\n\t\t\t\t\tz-index: (@flowProgressBarZIndex + 1);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t@media (max-width: @longWorkflowServiceNameWidth) {\n\t\t@progressLineWidth: 66px;\n\t\tpadding: 10px 30px 20px 30px;\n\n\t\tsection {\n\t\t\t.progressLine {\n\t\t\t\twidth: @progressLineWidth;\n\t\t\t}\n\n\t\t\t.progressText {\n\t\t\t\twidth: (@progressLineWidth + @progressIconSize);\n\t\t\t\tright: (-(@progressLineWidth / 2));\n\t\t\t\tfont-size: 12px;\n\t\t\t}\n\t\t}\n\t}\n\n\t@media (max-width: @phoneOnlyMaxWidth) {\n\t\t@progressLineWidth: 66px;\n\t\tposition: relative;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tmargin: 4px auto;\n\t\tpadding: 0 10px 20px 10px;\n\t\twidth: 100%;\n\t\tmax-width: calc(100% - 20px);\n\t\tbackground-color: transparent;\n\t\tborder-bottom: none;\n\t\tjustify-content: flex-start;\n\t\tscroll-padding-left: 10px;\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tflex: 1 1 0;\n\t\t\tmin-width: 0;\n\t\t}\n\t\tsection {\n\t\t\t&:first-child {\n\t\t\t\tmargin-left: 30px;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
